import { RootState } from "@/store/dtm";
import { addressType } from "@/types/addressType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface addressInfo extends addressType {
    displayId: string,
    manualAddressEntered: boolean,
    yearsLivedOn: number | undefined,
    monthsLivedOn: number | undefined
}

export interface previousAddressState {
    addresses: addressInfo[]
}

const initialState: previousAddressState = {
    addresses: []
}


export const previousAddressSlice = createSlice({
    name: "previousAddress",
    initialState,
    reducers: {
        addPreviousAddress: (state, action: PayloadAction<addressInfo>) => {
            const address = action.payload;
            state.addresses.push(address);
        },
        setAddressInfo:  (state, action: PayloadAction<addressInfo>) => {
            const addrInfo = action.payload;
            state.addresses = state.addresses.map(addr => addr.displayId == addrInfo.displayId ? addrInfo : addr);
        },
        removePreviousAddress: (state, action: PayloadAction<string>) => {
            const id = action.payload;
            state.addresses = state.addresses.filter(address => address.displayId != id);
        },
        clearPreviousAddressState: (state) => {
            state.addresses = []
        }
    }
});

export const { addPreviousAddress, setAddressInfo, removePreviousAddress, clearPreviousAddressState } = previousAddressSlice.actions

export default previousAddressSlice.reducer

export const selectPreviousAddress = (state: RootState) => state.previousAddresses;